import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 */

export const products = [
  {
    _id: uuid(),
    title: "Comfortable Lounge Chair",
    description: "A comfortable lounge chair for relaxing at home.",
    price: "5000",
    imageUrl: "https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=765&q=80",
    rating: 4.5,
    categoryName: "chairs",
  },
  {
    _id: uuid(),
    title: "Elegant Armchair",
    description: "An elegant armchair for adding a touch of luxury.",
    price: "3500",
    imageUrl: "https://plus.unsplash.com/premium_photo-1668073439372-2ceafa1222b7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80",
    rating: 4.8,
    categoryName: "chairs",
  },
  {
    _id: uuid(),
    title: "Vintage Wooden Chair",
    description: "A vintage wooden chair with a classic design.",
    price: "2800",
    imageUrl: "https://images.unsplash.com/photo-1519947486511-46149fa0a254?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80",
    rating: 4.2,
    categoryName: "chairs",
  },
  {
    _id: uuid(),
    title: "Modern Office Chair",
    description: "A modern office chair for comfortable work hours.",
    price: "6700",
    imageUrl: "https://images.unsplash.com/photo-1600093328589-39ed150b382b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=688&q=80",
    rating: 4.6,
    categoryName: "chairs",
  },
  {
    _id: uuid(),
    title: "Contemporary Dining Chair",
    description: "A contemporary dining chair for stylish dining spaces.",
    price: "3900",
    imageUrl: "https://images.unsplash.com/photo-1611464908623-07f19927264e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTJ8fGNoYWlyc3xlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=700&q=60",
    rating: 4.9,
    categoryName: "chairs",
  },
  {
    _id: uuid(),
    title: "Casual Lounge Chair",
    description: "A casual lounge chair for laid-back moments.",
    price: "2100",
    imageUrl: "https://images.unsplash.com/photo-1561677978-583a8c7a4b43?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTV8fGNoYWlyc3xlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=700&q=60",
    rating: 4.0,
    categoryName: "chairs",
  },
  {
    _id: uuid(),
    title: "Stylish Accent Chair",
    description: "A stylish accent chair for adding flair to interiors.",
    price: "1500",
    imageUrl: "https://images.unsplash.com/photo-1567538096621-38d2284b23ff?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzR8fGNoYWlyc3xlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=700&q=60",
    rating: 3.7,
    categoryName: "chairs",
  },
  
  
  {
    _id: uuid(),
    title: "Comfort Sofa",
    description: "A cozy and comfortable sofa for your living room.",
    price: "8000",
    imageUrl: "https://images.unsplash.com/photo-1540574163026-643ea20ade25?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=870&q=80",
    rating: 4.7,
    categoryName: "sofas",
  },
  {
    _id: uuid(),
    title: "Modern Sectional Sofa",
    description: "A modern sectional sofa with sleek design.",
    price: "6000",
    imageUrl: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDF8fHxlbnwwfHx8fHw%3D&auto=format&fit=crop&w=300&q=60",
    rating: 4.3,
    categoryName: "sofas",
  },
  {
    _id: uuid(),
    title: "Classic Sofa",
    description: "A classic sofa with timeless design.",
    price: "7200",
    imageUrl: "https://images.unsplash.com/photo-1484101403633-562f891dc89a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDl8fHxlbnwwfHx8fHw%3D&auto=format&fit=crop&w=300&q=60",
    rating: 4.5,
    categoryName: "sofas",
  },
  {
    _id: uuid(),
    title: "Elegant Sofa",
    description: "An elegant sofa for your luxurious living room.",
    price: "5200",
    imageUrl: "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8c29mYXxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=700&q=60",
    rating: 4.9,
    categoryName: "sofas",
  },
  {
    _id: uuid(),
    title: "Minimalist Sofa",
    description: "A minimalist sofa for modern and clean interiors.",
    price: "4600",
    imageUrl: "https://images.unsplash.com/photo-1550581190-9c1c48d21d6c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8c29mYXxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=700&q=60",
    rating: 4.2,
    categoryName: "sofas",
  },
  {
    _id: uuid(),
    title: "Vintage Sofa",
    description: "A vintage-inspired sofa for a touch of nostalgia.",
    price: "5700",
    imageUrl: "https://images.unsplash.com/photo-1512212621149-107ffe572d2f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fHNvZmF8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=700&q=60",
    rating: 4.1,
    categoryName: "sofas",
  },
  {
    _id: uuid(),
    title: "Modern Gray Sofa",
    description: "A sleek and stylish gray sofa for modern interiors.",
    price: "6800",
    imageUrl: "https://images.unsplash.com/photo-1573866926487-a1865558a9cf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTZ8fHNvZmF8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=700&q=60",
    rating: 4.6,
    categoryName: "sofas",
  },
  {
    _id: uuid(),
    title: "Modern Desk Lamp",
    description: "A modern desk lamp with adjustable brightness.",
    price: "85",
    imageUrl: "https://images.unsplash.com/photo-1517991104123-1d56a6e81ed9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8bGFtcHN8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=700&q=60",
    rating: 4.3,
    categoryName: "lamps",
  },
  {
    _id: uuid(),
    title: "Vintage Table Lamp",
    description: "A vintage table lamp for classic interiors.",
    price: "95",
    imageUrl: "https://images.unsplash.com/photo-1513506003901-1e6a229e2d15?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8bGFtcHN8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=700&q=60",
    rating: 4.1,
    categoryName: "lamps",
  },
  {
    _id: uuid(),
    title: "Minimalist Floor Lamp",
    description: "A minimalist floor lamp for modern interiors.",
    price: "120",
    imageUrl: "https://images.unsplash.com/photo-1592195986398-5484c0890b74?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTd8fGxhbXBzfGVufDB8fDB8fHww&auto=format&fit=crop&w=700&q=60",
    rating: 4.5,
    categoryName: "lamps",
  },
  {
    _id: uuid(),
    title: "Classic Bedside Lamp",
    description: "A classic bedside lamp for cozy nights.",
    price: "75",
    imageUrl: "https://images.unsplash.com/photo-1455792244736-3ed96c3d7f7e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjB8fGxhbXBzfGVufDB8fDB8fHww&auto=format&fit=crop&w=700&q=60",
    rating: 4.0,
    categoryName: "lamps",
  },
  {
    _id: uuid(),
    title: "Modern Hanging Lamp",
    description: "A modern hanging lamp for contemporary spaces.",
    price: "150",
    imageUrl: "https://plus.unsplash.com/premium_photo-1681412205156-bb506a4ea970?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8dGFibGUlMjBsYW1wfGVufDB8fDB8fHww&auto=format&fit=crop&w=700&q=60",
    rating: 4.7,
    categoryName: "lamps",
  },
  {
    _id: uuid(),
    title: "Geometric Table Lamp",
    description: "A geometric table lamp for modern interiors.",
    price: "110",
    imageUrl: "https://images.unsplash.com/photo-1573676386604-78f8ed228e2b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8dGFibGUlMjBsYW1wfGVufDB8fDB8fHww&auto=format&fit=crop&w=700&q=60",
    rating: 4.4,
    categoryName: "lamps",
  },
  {
    _id: uuid(),
    title: "Modern Pendant Lamp",
    description: "A modern pendant lamp for minimalist spaces.",
    price: "130",
    imageUrl: "https://images.unsplash.com/photo-1565374235393-6fe32a07cc86?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTJ8fHRhYmxlJTIwbGFtcHxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=700&q=60",
    rating: 4.6,
    categoryName: "lamps",
  },
  {
    _id: uuid(),
    title: "Art Deco Table Lamp",
    description: "An art deco table lamp for luxurious spaces.",
    price: "175",
    imageUrl: "https://images.unsplash.com/photo-1609847214283-8bad801da710?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fHRhYmxlJTIwbGFtcHxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=700&q=60",
    rating: 4.8,
    categoryName: "lamps",
  },
  
  
];
